const zhGamesData = {
    "counter_strike_2": "反恐精英2",
    "counter_strike_2_genre": "第一人称射击",
    "counter_strike_2_about": "二十多年来，在全球数百万玩家的共同铸就下，《反恐精英》提供了精湛绝伦的竞技体验。而如今，CS 传奇的下一章即将揭开序幕，那就是《反恐精英2》。",
    "marvel_rivals": "漫威争锋",
    "marvel_rivals_genre": "免费游玩、多人",
    "marvel_rivals_about": "《漫威争锋》是一款由漫威IP正版授权、网易自研的超级英雄PVP团队射击游戏。玩家可以从丰富多样的超级英雄阵容中挑选心仪角色，组成全明星队伍，在漫威多元宇宙中各种可破坏的地图上，利用独特的超能力进行精彩激战。成为超级英雄，集结你的小队，一起战斗吧！",
    "dota_2": "Dota 2",
    "dota_2_genre": "射击",
    "dota_2_about": "每一天全球有数百万玩家化为一百余名Dota英雄展开大战。不论是游戏时间刚满10小时还是1000小时，比赛中总能找到新鲜感。定期的更新则保证游戏性、功能和英雄都能持续发展，Dota 2已真正地焕发了生命。",
    "monster_hunter_wilds": "怪物猎人 荒野",
    "monster_hunter_wilds_genre": "狩猎、动作",
    "monster_hunter_wilds_about": "狂野凶猛的大自然，袭来。 时刻都在动态变化的原野。 这是个关于生活在具有两面性的世界中的怪物与人们的故事。 进化的狩猎动作，寻求连续不断的沉浸感，究极的狩猎体验正等待你的到来。",
    "stardew_valley": "星露谷物语",
    "stardew_valley_genre": "农场模拟",
    "stardew_valley_about": "你继承了你爷爷在星露谷留下的老旧农场。带着爷爷留下的残旧工具和几枚硬币开始了你的新生活。你能适应这小镇上的生活并且将这个杂草丛生的老旧农场变成一个繁荣的家吗？",
    "repo": "R.E.P.O",
    "repo_genre": "抢先体验、恐怖",
    "repo_about": "一款最多支持6名玩家的在线合作恐怖游戏。寻找珍贵的、完全基于物理原理的物品，并在取回和提取过程中小心处理，以满足创造者的愿望。",
    "destiny_2": "命运2",
    "destiny_2_genre": "免费游玩、开放世界",
    "destiny_2_about": "《命运2》是发生在一个独立进化的世界中的一款免费的大型多人线上动作游戏。你可以在任何时间与任何地点和你的朋友们进行游戏。",
    "ea_sports_fc_25": "EA SPORTS FC™ 25",
    "ea_sports_fc_25_genre": "体育",
    "ea_sports_fc_25_about": "《EA SPORTS FC™ 25》将为您带来更多为俱乐部奋勇争胜的方式。在您最喜爱的模式中通过全新 5 对 5 Rush 与好友并肩作战，借助 FC IQ 以前所未有的强大战术掌控力引领您的俱乐部走向胜利。",
    "cyberpunk_2077": "赛博朋克2077",
    "cyberpunk_2077_genre": "赛博朋克",
    "cyberpunk_2077_about": "《赛博朋克 2077》是一款开放世界动作冒险 RPG 游戏。故事发生在暗黑未来的夜之城，一座五光十色、危机四伏的超级大都会，权力更迭和无尽的身体改造是这里不变的主题。",
    "rust": "腐蚀",
    "rust_genre": "生存",
    "rust_about": "《腐蚀》中唯一的目标就是生存。一切都想让你死——岛上的野生动物、其他居民、周围的环境，以及其他幸存者。尽一切努力，撑过下一个夜晚。",
    "pubg_battlegrounds": "绝地求生：大逃杀",
    "pubg_battlegrounds_genre": "生存、射击、大逃杀",
    "pubg_battlegrounds_about": "在丰富多变的地图中降落，搜寻独特武器和物资，在不断缩小的安全区中求生，每个转角都可能是你的末路。",
    "apex_legends": "Apex 英雄",
    "apex_legends_genre": "免费游玩、大逃杀、多人",
    "apex_legends_about": "在这款革命性的新一代大逃杀英雄射击游戏中，掌控日益丰富且拥有强大技能的传奇角色，深度体验战术小队玩法及创新游戏元素。",
    "rainbow_six_siege": "彩虹六号：围攻",
    "rainbow_six_siege_genre": "FPS、PvP、多人",
    "rainbow_six_siege_about": "《彩虹六号：围攻》是一款精英团队战术射击游戏，高超的策略和行动力是制胜关键。",
    "warframe": "星际战甲",
    "warframe_genre": "免费游玩、动作RPG、掠夺射击",
    "warframe_about": "在这个以故事为导向的免费在线动作游戏中，觉醒为一个不可阻挡的战士，并与你的朋友一起战斗。跟随着神秘的 Lotus 的指引，在广阔的星系中直面敌对的派系，提升你的战甲等级，建立一个具有毁灭性火力的军械库；并在这个惊心动魄，且拥有独特第三人称战斗体验的庞大开放世界中发挥你的真正潜力。",
    "team_fortress_2": "军团要塞2",
    "team_fortress_2_genre": "免费游玩、多人",
    "team_fortress_2_about": "九种不同的兵种各自具备不同的作战能力和性格，不断更新的游戏模式、地图、装备，当然还有最重要的——头饰！",
    "palworld": "幻兽帕鲁",
    "palworld_genre": "开放世界、生存、生物收集",
    "palworld_about": "在广阔的世界中收集神奇的生物“帕鲁”，派他们进行战斗、建造、做农活，工业生产等，这是一款支持多人游戏模式的全新开放世界生存制作游戏。",
    "elden_ring": "艾尔登法环",
    "elden_ring_genre": "魂类、黑暗奇幻、RPG",
    "elden_ring_about": "《艾尔登法环》是以正统黑暗奇幻世界为舞台的动作RPG游戏。 走进辽阔的场景与地下迷宫探索未知，挑战困难重重的险境，享受克服困境时的成就感吧。 不仅如此，登场角色之间的利害关系谱成的群像剧，更是不容错过。",
    "the_sims_4": "模拟人生4",
    "the_sims_4_genre": "生活模拟",
    "the_sims_4_about": "在一个无拘无束的虚拟世界中，享受创造和控制人生的奇妙力量。 得到力量和自由，享受快乐，游戏人生！",
    "overwatch_2": "守望先锋2",
    "overwatch_2_genre": "免费游玩、多人",
    "overwatch_2_about": "《守望先锋》“归来”是一款广受好评的团队射击游戏，舞台设定在光明的未来，有着不断进化的英雄阵容。现在就与好友组队畅玩吧！",
    "civilization_vi": "文明6",
    "civilization_vi_genre": "策略",
    "civilization_vi_about": "扩张疆域，发展文化，并与历史上最伟大的领袖正面交锋。你的文明是否能经得起时间的考验？",
};

export default zhGamesData;
